import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { InputGroup, InputGroupAddon, InputGroupText, Input, Button, FormGroup, Label } from "reactstrap";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import Col from "reactstrap/lib/Col";
import Row from "reactstrap/lib/Row";
import { labelAlignment } from "../../../helpers/labelAlignment";
import { attendeeActions } from "../../../../store/actions/attendee/attendee.action";
import { deepClone } from "../../../../helpers/objectHelper";
import Alert from "@material-ui/lab/Alert";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { Avatar, ListItem, ListItemAvatar, ListItemIcon, ListItemText } from "@material-ui/core";
const Discount = (props) => {
  const [code, setCode] = useState("");
  const [isValid, setIsValid] = useState(null);
  const [isChangeLocked, setIsChangeLocked] = useState(false);
  const [validCodes, setValidCodes] = useState([]);

  const { cms, template, previewDevice, element, attendee, form } = props;
  const { input, label, button } = template;

  useEffect(() => {
    setIsChangeLocked(attendee && attendee.orders && attendee.orders.length > 0 && attendee.orders[0].orderId !== undefined && element.data.changeLock);
    fetchEarlyBird();
    fetchOrderDiscounts();
  }, []);

  useEffect(() => {
    fetchEarlyBird();
  }, [attendee.activePersonNo]);

  const fetchEarlyBird = () => {
    axios.get(`./api/discount/${form.eventId}`).then(({ data }) => {
      console.log(data);
      if (data && !cms.editMode) {
        let order = deepClone(attendee.orders[attendee.activePersonNo]);

        if (!Array.isArray(order.discounts)) {
          order.discounts = [];
        }

        if (!order.discounts.find((d) => data.find((dd) => dd.code == d.code))) {
          setValidCodes([...validCodes, ...data]);
          props.dispatch(attendeeActions.updateDiscounts([...order.discounts, ...data], attendee.activePersonNo));
        }
        /*  else if (data && !order.discounts.find((d) => d.code == data.code)) {
          order.discounts.push(data);

          setValidCodes([...validCodes, data]);

          props.dispatch(attendeeActions.updateDiscounts(order.discounts, attendee.activePersonNo));
        } */
      }
    });
  };

  const fetchOrderDiscounts = () => {
    if (attendee.orders && attendee.orders.length > 0 && !cms.editMode && attendee.orders[attendee.activePersonNo].orderId > 0) {
      axios.get(`./api/discount/mydiscounts/${attendee.orders[attendee.activePersonNo].orderId}`).then(({ data }) => {
        if (data) {
          /* let order = deepClone(attendee.orders[attendee.activePersonNo]);

          if (!Array.isArray(order.discounts)) {
            order.discounts = [];
          } */
          /*           order.discounts = [...order.discounts, ...data]; */

          setValidCodes([...validCodes, ...data]);
          /*       props.dispatch(attendeeActions.updateOrder(order, attendee.activePersonNo)); */
        }
      });
    }
  };

  const validateCode = () => {
    const { dispatch } = props;
    axios.get(`./api/discount/validate/${form.eventId}?code=${code}`).then(({ data }) => {
      const rebate = data;

      if (rebate) {
        let order = deepClone(attendee.orders[attendee.activePersonNo]);

        if (!Array.isArray(order.discounts)) {
          order.discounts = [];
        }

        if (order.discounts.find((d) => d.code == rebate.code)) return;

        order.discounts.push(rebate);
        setCode("");
        setIsValid(true);
        setValidCodes([...validCodes, rebate]);

        console.log("discount", order.orderRow, order, attendee.activePersonNo);
        dispatch(attendeeActions.updateOrder(order, attendee.activePersonNo));
      } else {
        setIsValid(false);
      }
    });
  };
  const inputOnChange = (code) => {
    setIsValid(null);
    setCode(code);
  };
  if (element && element.data && element.data.hidden && !cms.editMode) return null;

  return (
    <div
      style={{
        width: "100%",
        padding: element.data && element.data.padding + "px",
      }}
      id={element.contentId}
    >
      {element.data.hidden ? (
        <div className="hidden-element">
          <i className="fa fa-eye-slash hidden-element-icon" />
        </div>
      ) : null}
      <Row style={{ flexDirection: labelAlignment(element.data.labelAlign), margin: "0px", display: cms.editMode && previewDevice === "smartphone" ? "block" : undefined }} className="responsive-row">
        <Col
          className="qs-label-col"
          style={{
            padding: "0px",
            maxWidth: cms.editMode && previewDevice === "smartphone" ? "100%" : element.data.labelAlign !== "center" && element.data.titleWidth !== undefined && element.data.titleWidth + "%",
            wordBreak: element.data.labelAlign !== "center" && "break-word",
            paddingTop: "5px",
          }}
        >
          <Label style={label} for="discountCode">
            <SystemLabel name="DiscountCode" />
          </Label>
        </Col>
        <Col
          className="responsive-input-slot"
          style={{
            padding: "0px",
            maxWidth: cms.editMode && previewDevice === "smartphone" ? "100%" : element.data.labelAlign !== "center" && element.data.inputWidth !== undefined && element.data.inputWidth + "%",
          }}
        >
          <InputGroup id="discountCode">
            <Input
              type={"text"}
              className="responsive-input"
              onChange={(e) => inputOnChange(e.target.value)}
              autoComplete="off"
              autoFocus={false}
              readOnly={isChangeLocked}
              required={element.data.required || false}
              value={code}
              valid={isValid == true}
              invalid={isValid == false}
              style={
                template && {
                  ...template.content.input,
                  width: cms.editMode && previewDevice === "smartphone" ? "100%" : element.data.style.width.toString().includes("%") ? element.data.style.width : element.data.style.width + "%",
                  maxWidth: cms.editMode && previewDevice === "smartphone" ? "100%" : element.data.style.width.toString().includes("%") ? element.data.style.width : element.data.style.width + "%",
                  wordBreak: "break-word",
                  opacity: isChangeLocked ? input.readOnlyOpacity : 1,
                  fontSize: input.fontSize + " !important",
                }
              }
            />
            <InputGroupAddon addonType="append">
              <Button
                style={{ backgroundColor: button.backgroundColor, color: button.color, fontFamily: button.fontFamily, marginLeft: 10, borderRadius: 5 }}
                disabled={isChangeLocked || !code}
                onClick={validateCode}
              >
                <SystemLabel name="Apply" />
              </Button>
            </InputGroupAddon>
          </InputGroup>
          <div
            style={{
              marginTop: 5,
              maxWidth: cms.editMode && previewDevice === "smartphone" ? "100%" : element.data.style.width.toString().includes("%") ? element.data.style.width : element.data.style.width + "%",
            }}
          >
            {isValid == false ? (
              <Alert severity="error">
                <SystemLabel name="NoCouponFound" />
              </Alert>
            ) : null}
          </div>
          <div
            style={{
              maxWidth: cms.editMode && previewDevice === "smartphone" ? "100%" : element.data.style.width.toString().includes("%") ? element.data.style.width : element.data.style.width + "%",
            }}
          >
            {validCodes.map((v, i) => {
              const { code, value, name, valueType } = v;
              return (
                <Fragment key={code}>
                  <ListItem className="applied-discount-item" style={{ background: "rgb(237, 247, 237)", padding: "0px 6px", borderRadius: 5, margin: "5px 0px", border: "1px solid #4caf50" }}>
                    <ListItemIcon>
                      <CheckCircleOutlineIcon style={{ fontSize: 32, color: "rgb(86 177 89)" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <span style={{ color: "rgb(30, 70, 32)", fontSize: "0.875rem" }}>
                          <strong>{code || name}</strong> <SystemLabel name="Applied" />
                        </span>
                      }
                      secondary={
                        <span style={{ color: "rgb(30, 70, 32, 0.7)" }}>
                          {`${value}${valueType == "Percent" ? "%" : " " + (props.form.currency || "SEK")} `} <SystemLabel name="Off" />
                        </span>
                      }
                    />
                  </ListItem>
                </Fragment>
              );
            })}
          </div>
        </Col>
      </Row>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    //maybe set rebates to redux
    selectedElement: state.form.selectedElement,
    form: state.form,
    event: state.event,
    /*     rElement: state.element, */
    template: state.template && state.template.template ? state.template.template.content : {},
    cms: state.cms,
    attendee: state.attendee,
  };
}

export default connect(mapStateToProps)(Discount);
{
  /* <Label for="discountCode">
<SystemLabel name="DiscountCode" />
</Label>
<InputGroup id="discountCode">
<Input
  style={{
    ...input,
    width: cms.editMode && previewDevice === "smartphone" ? "100%" : element.data.style.width.toString().includes("%") ? element.data.style.width : element.data.style.width + "%",
    wordBreak: "break-word",
    opacity: isReadOnly ? template.content.input.readOnlyOpacity : 1,
    fontSize: template.content.input.fontSize + " !important",
  }}
  placeholder="Check it out"
/>
<InputGroupAddon addonType="append">
  <Button onClick={validateCode}>
    <SystemLabel name="Apply" />
  </Button>
</InputGroupAddon>
</InputGroup> */
}
